import { Footer, Header, SidebarLayout } from '@scuf/common'
import React, { useCallback, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import IdleModal from './IdleModal'
import pdf from '../../../assets/UDP.pdf'
import { escapeHTML } from '../../../utils/escapeHTML'
import { useDispatch } from 'react-redux'
import { changeHamburgerState } from '../redux/hamburgerSlice'

const DashboardLayout = (props: any): any => {
  const dispatch = useDispatch()
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true)
  const auth = useAuth()

  const onCollapsedClick = (): any => {
    dispatch(changeHamburgerState(sidebarCollapsed ? 'open' : 'close'))
    setSidebarCollapsed(!sidebarCollapsed)
  }

  const onLogout = (): void => {
    auth.signoutRedirect({
      post_logout_redirect_uri: escapeHTML(window.location.origin) + '/logout'
    })
      .catch((e) => {
        console.log(e)
      })
  }
  const navigate = useNavigate()
  const handleHomeOnClick = useCallback(() => {
    navigate('/', { replace: true })
  }, [navigate])
  const handleHelpClick = (): any => {
    window.open(pdf, '_blank')
  }

  const shouldShowSearchIcon = (): boolean => {
    return false
  }

  return (
        <div id='MainLayoutFlexContainer' data-testid='Home'>
            <Header title='' onMenuToggle={() => onCollapsedClick()}>
                { shouldShowSearchIcon() && (<Header.Search onSearch={() => undefined}/>) }
                {auth.isAuthenticated
                  ? <Header.UserProfile firstName={auth.user?.profile.given_name ?? ''}
                                          lastName={auth.user?.profile.family_name}
                                          imageUrl={auth.user?.profile.picture}>
                        <Header.UserProfile.Item data-testid="logout-id" onClick={onLogout}>Log
                            out</Header.UserProfile.Item>
                    </Header.UserProfile>
                  : <></>
                }
            </Header>
            <div id='bottom-flex-container'>
                <SidebarLayout collapsed={sidebarCollapsed} className='example-sidebar'>
                    <SidebarLayout.Sidebar>
                        <SidebarLayout.Sidebar.Item content='My Dashboard' icon='home' onClick={handleHomeOnClick}
                                                    test-id='Home'/>
                        <SidebarLayout.Sidebar.Item
                            content='Asset Management'
                            icon='document-blank'
                            aria-label='notification'
                            onClick={() => {
                              navigate('/card')
                            }}
                        />
                        <SidebarLayout.Sidebar.Item content='help' icon='badge-help'
                                                    data-testid='help' onClick={handleHelpClick}/>
                    </SidebarLayout.Sidebar>
                    <SidebarLayout.Content>
                        <div id='sidebar-layout-content-flex-container' className='sidebar-layout-content'>
                            <div className='outlet-content'>
                                <Outlet/>
                            </div>
                            <Footer>
                                <Footer.Item href='#'>Terms & Conditions</Footer.Item>
                                <Footer.Item href='https://www.honeywell.com/us/en/privacy-statement' target='_blank'>Privacy Policy</Footer.Item>
                            </Footer>
                        </div>
                    </SidebarLayout.Content>
                </SidebarLayout>
            </div>
            <div className='IdleModal'>

                {auth.isAuthenticated
                  ? <IdleModal onLogout={onLogout} />
                  : <></>
                }
            </div>
        </div>
  )
}

export default DashboardLayout
